import { IPaymentMethod } from "../payment/method/payment-method.interface";

export interface IOpenSchedule {
  scheduleId: number;
  scheduleDate: string;
  scheduleHour: number;
  dateAndHour: string;
  customerRemarks: string;

  country: string;
  divisionId: number;

  // dealer
  dealerName: string;
  dealerAddress: string;
  dealerId: number;
  dealer: number;
  advisorId: number;
  advisor?: number;
  advisorName: string;

  pickupDelivery: boolean;
  winchService: boolean;
  mobileService: boolean;

  // payments
  paymentMethod: IPaymentMethod[];
  totalAlreadyPaid: number;

  // services
  services: IServiceBySchedule[];

  // vehicle
  vin: string;
  vehicleModel: string;
  vehiclePlate: string;
  vehicleModelYear: string;

  // Modalide do ageendamento
  modality: string;

  rescheduleEnabled: boolean;
}


interface IServiceBySchedule {
  serviceId: number;
  localName: string;
  serviceName: string;
  pickupDelivery: string;
  revision: string;
  mobileService: string;
}
